/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  inject,
  Input,
  output,
  viewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-input-search',
  templateUrl: './m-input-search.component.html',
  styleUrls: ['./m-input-search.component.scss'],
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MInputSearchComponent),
      multi: true
    }
  ]
})
export class MInputSearchComponent {
  @Input() value: any = '';
  readonly inputBlur = output<void>();
  @Input() placeholder = '';
  @Input() disabled = false;

  readonly searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');

  private readonly cd = inject(ChangeDetectorRef);

  onChange: any = () => {};
  onTouched: any = () => {};

  focus(): void {
    this.searchInput()?.nativeElement?.focus();
  }

  onBlur(): void {
    this.onTouched();
    this.inputBlur.emit();
  }

  onValueChange(newValue: any): void {
    this.value = newValue;
    this.onChange(newValue);
  }

  clearInput(): void {
    this.onValueChange('');
  }

  writeValue(value: any): void {
    this.value = value;
    this.cd.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
